import { Patient, GameTimingMode } from "@models/patient";

/** Caregiver-controlled per-patient preferences (games, companion, etc.). */
export interface PatientSettings {
  gameTimingMode: GameTimingMode;
  inGameMoreTimeAllowed: boolean;
  manualDifficultyEnabled: boolean;
  manualDifficultyLevel: number;
  gameVoiceOverPrefs: Record<string, boolean>;
  openWithDateLocation: boolean;
}

export function mergePatientSettings(
  patient: Patient,
  settings: Partial<PatientSettings>,
): Patient {
  return { ...patient, ...settings };
}
